import API from '../Services/API';
import Model from './Model';
import State from './State';

const useWeekOverview = (week, alwaysRefresh = false) => {
    return Model({
        subscribeToUpdates: {
            topic: 'schedule-suggestions',
            handler: (event, opts) => opts.refresh(),
        },
        stateKey: ['week-overview', week ?? 'current'],
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/app/weekOverview${week ? `/${week}` : ''}`),
        returnDataKey: 'overview',
        saveAdditionalData: (overview) => {
            Object.values(overview?.dates ?? {}).forEach(day => {
                [...day?.scheduledJobs ?? [], ...day?.suggestedJobs ?? []].forEach(job => {
                    State.putIfNotExists(['job', job.id], job);

                    if (job.customer) {
                        State.putIfNotExists(['customer', job.customer.id], job.customer);
                    }
                });
            });
        },
        defaultLoadingError: 'Sorry, there was an error loading the week overview.',
        registerAdditionalMethods: (opts) => ({
            executeTrigger: (triggerId, date) => opts.wrapUpdateCall(
                () => API.post(`/triggers/${triggerId}/execute`, { date }),
                null,
                true,
            ),
        }),
    });
};

export {
    useWeekOverview,
};
